<template>
  <div class="body">
    <b-modal id="userprofile-modal" centered>
            <div slot="modal-header">
                <h4 class=" font-weight-bold">User Profile</h4>
            </div>
            <div class="container">
                   <div class="row mb-2">
                    
                    <div class="px-3 py-2">
                        <h5 class="m-0">Full Name:  <span>{{ provider.username }}</span></h5>
                        <!-- <div>
                          <small>{{ provider.provider_id }} </small>
                        </div> -->
                        <h5>User ID   :  <span> {{ provider.userid }}</span></h5>
                        <div>
                          <h5>User Profile: {{ provider.profile }} </h5>
                        </div>
                    </div>
                </div>
                   <div class="container-fluid">
            <b-form-group>
              <b-input-group>
                <b-form-input placeholder="New password" type="password" v-model="userinfo.sz_password"></b-form-input>
                <b-input-group-text slot="prepend">
                  <i class="fa fa-asterisk"></i>
                </b-input-group-text>
              </b-input-group>
            </b-form-group>
                   </div>
                    </div>
            <div slot="modal-footer" class="d-block w-100">
                <b-button  pill variant="success" class="btn btn-success" @click="UpdateUserDetail" :disabled="loading">
                  <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                  <template v-else>Update Account</template></b-button>
            </div>
        </b-modal>
    <nav class="navbar navbar-expand-lg navbar-light bg-white p-0">
      <div class="container-fluid">
        <a class="navbar-brand" href="#">
          <div class="row align-items-center">
            <img class="pl-4" src="@/assets/ikolilu.png" height="70px" alt="logo" />
            <div class="font-weight-bold">for providers</div>
          </div>
        </a>
        <ul class="navbar-nav ml-auto">
          <li class="nav-link d-none d-block d-md-none px-5">
          <a @click='toggleShow' class='anchor font-weight-bold'><i class="fa fa-bars fa-2x"></i></a>
          <div v-if='showMenu' class='menu'>
            <div class='menu-item' @click='toggleShow'><router-link class="text-dark" to="/" exact>My Schools</router-link>
</div>
            <div class="menu-item" @click='toggleShow'><router-link class="text-dark" to="/info" exact>School Info</router-link></div>
            <div class="menu-item" @click='toggleShow'><router-link class="text-dark" to="/billing" exact>Transactions</router-link></div>
           
            <div class="menu-item" @click="logout()">Logout</div>
			</div>
        </li>
          <li class="nav-link d-none d-md-block" v-b-modal="'userprofile-modal'" style="color: black; cursor:pointer">Profile</li>
          <li class="nav-link d-none d-md-block" @click="logout()" style="color: black; cursor:pointer">Logout</li>
        </ul>
      </div>
    </nav>
    <div class="row">
      <nav class="col-md-2 d-none d-md-block p-0" style=" background-color: #e8f9e3">
        <div v-if="this.provider.profile === 'Administrator'" class="sidebar-sticky" style="padding-left: 15px;">
          <ul class="nav flex-column text-left mt-3">
             <li class="nav-item">
              <router-link class="nav-link text-dark" to="/" exact>Verify School</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/detail" exact>My Schools</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/approveschool" exact>Approvals</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/info" exact>Student Data</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/billing" exact>Transactions</router-link>
            </li>
             <li class="nav-item">
              <router-link class="nav-link text-dark" to="/userman" exact>User Management</router-link>
            </li>
          </ul>
        </div>
        <div v-else class="sidebar-sticky" style="padding-left: 15px;">
          <ul class="nav flex-column text-left mt-3">
             <!-- <li class="nav-item">
              <router-link class="nav-link text-dark" to="/" exact>Verify School</router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/detail" exact>My Schools</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link class="nav-link text-dark" to="/approveschool" exact>Approvals</router-link>
            </li> -->
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/info" exact>Student Data</router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link text-dark" to="/billing" exact>Transactions</router-link>
            </li>
          </ul>
        </div>
      </nav>

      <main
        role="main"
        class="col-md-9 ml-sm-auto col-lg-10 p-0"
        style=" overflow-x: hidden; height:90vh;"
      >
        <router-view></router-view>
      </main>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import http from "@/network/Base.js";

export default {
  data() {
    return {
      loading: false,
      isLoggingIn: true,
      showMenu: false,
      userinfo: {
        sz_userid : '',
        sz_password: '',
      }
    };
  },
  methods: {
    // dropDown(){
    //   this.drop = !left.drop
    // },
    toggleShow: function() {
			this.showMenu = !this.showMenu;
		},
    logout() {
      this.$store.dispatch("provider/unSetProviderCode");
      this.$router.push("/login");
    },
    UpdateUserDetail(){
       // this.$Progress.start()
        //this.loading = true
        this.userinfo.sz_userid = this.provider.userid
        http().post("/ChangeProviderUserPassword/", this.userinfo)
           .then(({data}) => {
               // console.log(data.success)
                this.$snotify.success(data.message.reason)
                if(data.success == 'true')
                {
                    // this.close();
                    $('#userprofile-modal').modal('hide')
                }

            })
            .catch(err => {
                this.$snotify.error('Error Updating your Account Details')
                //this.$Progress.finish()
            })
            .finally(() => {
                //this.loading = false
                //this.$Progress.finish()

            })
    }
  },
  computed: {
    ...mapState({
      provider: state => state.provider
    }),
  }
};
</script>

<style scoped>
.body {
  overflow-x: hidden;
  overflow-y: hidden;
  height: 100vh;
}
    .company {
    display: inline-block;
    width: 100px;
    height: 100px;
    border-radius: 50%;

    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}
.logo {
  background-image: url('https://gifimage.net/wp-content/uploads/2017/10/click-gif-12.gif');
}
.navbar-custom {
  background-color: white;
}
.nav-item:active {
  border-left: 6px solid rgb(0, 162, 255);
  background-color: rgba(0, 162, 255, 0.315);
}
.router-link-exact-active {
  border-left: 7px solid rgb(68, 105, 119);
}
.menu {
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid rgba(0,0,0,.15);
	border-radius: .25rem;
	color: #212529;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	font-size: 1rem;
	list-style: none;
	margin: .125rem 0 0;
  margin-left: -7rem;
	padding: .1rem 0;
  z-index: 2;
	position: absolute;
	text-align: left;
}

.menu-item {
	color: #212529;
	padding: .25rem 1.5rem;
	transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.menu-item:hover {
	background-color: #F4F6F6;
	cursor: pointer;
}
</style>
